import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo, useEffect, useContext } from 'react';
import { isResponse } from '@mummssoftware/utils/api/Request';
import { getPNOrders } from '@mummssoftware/utils/pimReader';
import { Bereavement, CarePlanFrequency, CarePlanProblems, DocLink, Measures, ClearScripts, ProgressNotes, STRING_FALSE, STRING_TRUE, PatientAssistance, Facesheet } from '@mummssoftware/utils/constants';
import { hashRoleGroupList, processRoleGroups, getRoleGroupPrn, filterRgHash, getRoleGroups, getPatientAssignments, mapRolesToOptions } from '@mummssoftware/utils/frequencies/frequency-utils';
import { SET_ROLE_GROUPS, VFGlobalContext, PNGlobalContext, ENTITY_PATIENT_CARE_PLAN_FREQUENCY, ENTITY_MEDICATION, ENTITY_PATIENT_CARE_GIVER, GlobalContext } from '@mummssoftware/global-context';
import { INCLUDE_PDF_CERT_APP, INCLUDE_PDF_TASKS_NOTES, INCLUDE_PDF_CPF_NOTES, INCLUDE_PDF_MEDICATIONS_NOTES, SET_ASYNC_PDF_DATA_READY, SET_PDF_CAREGIVERS_INFO, SET_JSON_MEASURES, SET_PDF_CARE_PLAN_PROBLEMS, SET_PDF_CERT_APP_SNAPSHOT, SET_PDF_CPF_NOTES, SET_PDF_MEASURES_GRAPH_IMAGES, SET_PDF_MEDICATIONS_NOTES, SET_PDF_PROGRESS_NOTES, SET_PDF_PSO_COMPONENTS, SET_PDF_RG_HASH, SET_PDF_RG_HASH_PRINT, SET_REACT_PRINT_ON, SET_PDF_BEREAV_NOTES, INCLUDE_PDF_BER_NOTES, SET_HISTORICAL_ROWS, SET_PDF_WEEKLY_TASKS, SET_PDF_TASKS_NOTES, SET_PDF_FACESHEET_DATA, SET_PDF_MEDICATIONS } from './constants';
import { toPSOComponents } from './utils';
const initialState = {
  pdfWeeklyTasks: null,
  includePdfTasksNotes: '',
  pdfTasksNotes: null,
  pdfCertAppSnapshot: null,
  includePdfCertApp: '',
  pdfFacesheetData: '',
  pdfCareGiversInfo: null,
  jsonMeasures: null,
  pdfMeasuresGraphImages: null,
  pdfMedications: null,
  pdfMedicationsNotes: null,
  includePdfMedicationsNotes: '',
  pdfBereavNotes: null,
  includepdfBereavNotes: '',
  pdfPSOComponents: null,
  pdfProgressNotes: null,
  pdfCarePlanProblems: null,
  asyncPdfDataReady: [],
  pdfCpfNotes: null,
  includePdfCpfNotes: '',
  pdfRgHash: null,
  pdfRgHashPrint: null,
  historicalRows: null,
  dispatchReactPDF: null,
  reactPrintOn: false
};
const initMummsPDFGlobalContext = {
  pdfWeeklyTasks: null,
  includePdfTasksNotes: '',
  pdfTasksNotes: null,
  pdfCertAppSnapshot: null,
  includePdfCertApp: '',
  pdfFacesheetData: '',
  pdfCareGiversInfo: null,
  jsonMeasures: null,
  pdfMeasuresGraphImages: null,
  pdfMedications: null,
  pdfMedicationsNotes: null,
  includePdfMedicationsNotes: '',
  pdfBereavNotes: null,
  includepdfBereavNotes: '',
  pdfPSOComponents: null,
  pdfProgressNotes: null,
  pdfCarePlanProblems: null,
  asyncPdfDataReady: [],
  pdfCpfNotes: null,
  includePdfCpfNotes: '',
  pdfRgHash: null,
  pdfRgHashPrint: null,
  historicalRows: null,
  dispatchReactPDF: null,
  reactPrintOn: false
};
export const MummsPDFGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_PDF_WEEKLY_TASKS:
      newState.pdfWeeklyTasks = action.payload;
      break;

    case INCLUDE_PDF_TASKS_NOTES:
      newState.includePdfTasksNotes = action.payload;
      break;

    case SET_PDF_TASKS_NOTES:
      newState.pdfTasksNotes = action.payload;
      break;

    case SET_PDF_CERT_APP_SNAPSHOT:
      newState.pdfCertAppSnapshot = action.payload;
      break;

    case INCLUDE_PDF_CERT_APP:
      newState.includePdfCertApp = action.payload;
      break;

    case SET_PDF_FACESHEET_DATA:
      newState.pdfFacesheetData = action.payload;
      break;

    case SET_PDF_CAREGIVERS_INFO:
      newState.pdfCareGiversInfo = action.payload;
      break;

    case SET_JSON_MEASURES:
      newState.jsonMeasures = action.payload;
      break;

    case SET_PDF_MEASURES_GRAPH_IMAGES:
      newState.pdfMeasuresGraphImages = action.payload;
      break;

    case SET_PDF_MEDICATIONS:
      newState.pdfMedications = action.payload;
      break;

    case SET_PDF_MEDICATIONS_NOTES:
      newState.pdfMedicationsNotes = action.payload;
      break;

    case INCLUDE_PDF_MEDICATIONS_NOTES:
      newState.includePdfMedicationsNotes = action.payload;
      break;
    // just used as a static reference to quickly access PSO text / not have to port over PN utils

    case SET_PDF_PSO_COMPONENTS:
      newState.pdfPSOComponents = action.payload;
      break;

    case SET_PDF_PROGRESS_NOTES:
      newState.pdfProgressNotes = action.payload;
      break;

    case SET_ASYNC_PDF_DATA_READY:
      newState.asyncPdfDataReady = action.payload;
      break;

    case SET_PDF_CARE_PLAN_PROBLEMS:
      newState.pdfCarePlanProblems = action.payload;
      break;

    case SET_PDF_CPF_NOTES:
      newState.pdfCpfNotes = action.payload;
      break;

    case INCLUDE_PDF_CPF_NOTES:
      newState.includePdfCpfNotes = action.payload;
      break;

    case SET_PDF_BEREAV_NOTES:
      newState.pdfBereavNotes = action.payload;
      break;

    case INCLUDE_PDF_BER_NOTES:
      newState.includepdfBereavNotes = action.payload;
      break;

    case SET_PDF_RG_HASH_PRINT:
      newState.pdfRgHashPrint = action.payload;
      break;

    case SET_PDF_RG_HASH:
      newState.pdfRgHash = action.payload;
      break;

    case SET_HISTORICAL_ROWS:
      newState.historicalRows = action.payload;
      break;

    case SET_REACT_PRINT_ON:
      newState.reactPrintOn = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const MummsPDFGlobalContext = /*#__PURE__*/createContext(initMummsPDFGlobalContext);
export const MummsPDFGlobalDispatchContext = /*#__PURE__*/createContext({});
export const MummsPDFGlobalContextConsumer = MummsPDFGlobalContext.Consumer;
export const MummsPDFGlobalDispatchContextConsumer = MummsPDFGlobalDispatchContext.Consumer;
export const MummsPDFGlobalContextProvider = ({
  keycloak,
  agency,
  patient,
  observation,
  children
}) => {
  const [{
    pdfWeeklyTasks,
    includePdfTasksNotes,
    pdfTasksNotes,
    pdfCertAppSnapshot,
    includePdfCertApp,
    pdfFacesheetData,
    pdfCareGiversInfo,
    jsonMeasures,
    pdfMeasuresGraphImages,
    pdfMedications,
    pdfMedicationsNotes,
    includePdfMedicationsNotes,
    includepdfBereavNotes,
    pdfBereavNotes,
    pdfPSOComponents,
    pdfProgressNotes,
    pdfCarePlanProblems,
    asyncPdfDataReady,
    pdfCpfNotes,
    includePdfCpfNotes,
    pdfRgHash,
    pdfRgHashPrint,
    historicalRows,
    reactPrintOn
  }, dispatch] = useReducer(MummsPDFGlobalContextReducer, initialState);
  const {
    patientStandingOrdersGlobal
  } = useContext(GlobalContext);
  const {
    progressNotesGlobal
  } = useContext(PNGlobalContext);
  const {
    dispatchVF,
    roleGroupsGlobal
  } = useContext(VFGlobalContext); // Facesheet

  useEffect(() => {
    if (pdfFacesheetData) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, Facesheet]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfFacesheetData]); // Bereavement

  useEffect(() => {
    if (pdfCareGiversInfo) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, Bereavement]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfCareGiversInfo]); // Care Plan Problems

  useEffect(() => {
    if (pdfCarePlanProblems) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, CarePlanProblems]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfCarePlanProblems]); // Care Plan Frequency

  const getHistoricalRows = carePlans => {
    const ret = [];
    Object.keys(carePlans).forEach(key => {
      carePlans[key].nonCurrentRows.forEach(el => {
        ret.push(el);
      });
    });
    return ret;
  };

  const getAllRgHashes = carePlanFrequencyPDF => {
    const {
      carePlans: cpfCarePlans,
      patientStandingOrdersGlobal: cpfPatientStandingOrdersGlobal,
      roleGroupsGlobal: cpfRoleGroupsGlobal,
      patient: cpfPatient,
      agency: cpfAgency,
      keycloak: cpfKeycloak
    } = carePlanFrequencyPDF;

    if (cpfCarePlans.length > 0) {
      const barebonesRgHash = hashRoleGroupList(cpfRoleGroupsGlobal);
      processRoleGroups(cpfCarePlans, barebonesRgHash, undefined).then(res => {
        if (!isResponse(res) && cpfPatient && cpfAgency) {
          dispatch({
            type: SET_HISTORICAL_ROWS,
            payload: getHistoricalRows(res[0])
          });
          const filteredRgHash = res[1];
          getPatientAssignments(filteredRgHash, cpfPatient === null || cpfPatient === void 0 ? void 0 : cpfPatient.patientNumber, cpfPatient === null || cpfPatient === void 0 ? void 0 : cpfPatient.id.toString(), cpfAgency, cpfKeycloak).then(() => {
            getRoleGroupPrn(cpfPatientStandingOrdersGlobal, filteredRgHash);
            dispatch({
              type: SET_PDF_RG_HASH,
              payload: filteredRgHash
            });

            const shallowRgHash = _objectSpread({}, filteredRgHash);

            const rgHashPrintData = filterRgHash(shallowRgHash, null, null);
            const rgHashPrintPayload = rgHashPrintData && rgHashPrintData.length ? rgHashPrintData.map(data => _objectSpread(_objectSpread({}, data), {}, {
              patientNumber: cpfPatient === null || cpfPatient === void 0 ? void 0 : cpfPatient.patientNumber
            })) : [];
            dispatch({
              type: SET_PDF_RG_HASH_PRINT,
              payload: rgHashPrintPayload
            });
          });
        }
      });
    } else {
      dispatch({
        type: SET_HISTORICAL_ROWS,
        payload: []
      });
      dispatch({
        type: SET_PDF_RG_HASH,
        payload: []
      });
      dispatch({
        type: SET_PDF_RG_HASH_PRINT,
        payload: []
      });
    }
  };

  useEffect(() => {
    if (includePdfCpfNotes === STRING_TRUE) if (pdfRgHash && pdfRgHashPrint && pdfCpfNotes) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, CarePlanFrequency]
      });
    }

    if (includePdfCpfNotes === STRING_FALSE) {
      if (pdfRgHash && pdfRgHashPrint) {
        dispatch({
          type: SET_ASYNC_PDF_DATA_READY,
          payload: [...asyncPdfDataReady, CarePlanFrequency]
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfRgHash, pdfRgHashPrint, includePdfCpfNotes, pdfCpfNotes]);
  useEffect(() => {
    if (observation && agency && patient && includePdfCpfNotes === STRING_TRUE) {
      observation.getWidgetPnNotes(patient === null || patient === void 0 ? void 0 : patient.patientNumber, agency, ENTITY_PATIENT_CARE_PLAN_FREQUENCY).then(res => {
        if (res) {
          dispatch({
            type: SET_PDF_CPF_NOTES,
            payload: res
          });
        }
      });
    }
  }, [agency, observation, patient, progressNotesGlobal, includePdfCpfNotes]);
  useEffect(() => {
    if (observation && agency && patient && includepdfBereavNotes === STRING_TRUE) {
      observation.getWidgetPnNotes(patient === null || patient === void 0 ? void 0 : patient.patientNumber, agency, ENTITY_PATIENT_CARE_GIVER).then(res => {
        if (res) {
          dispatch({
            type: SET_PDF_BEREAV_NOTES,
            payload: res
          });
        }
      });
    }
  }, [includepdfBereavNotes]);
  useEffect(() => {
    if (keycloak && agency && !roleGroupsGlobal) {
      getRoleGroups(keycloak, agency).then(res => {
        // double API call with Care Plan Frequency
        const roleGroupOptions = mapRolesToOptions(res);

        if (res) {
          dispatchVF({
            type: SET_ROLE_GROUPS,
            payload: roleGroupOptions
          });
        }
      });
    }
  }, [agency, dispatchVF, keycloak, roleGroupsGlobal]); // Cert-App / Certifications

  useEffect(() => {
    if (pdfCertAppSnapshot && includePdfCertApp === STRING_TRUE) {
      dispatch({
        type: INCLUDE_PDF_CERT_APP,
        payload: ''
      });
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, DocLink]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [includePdfCertApp, pdfCertAppSnapshot]); // Patient Assistance / Tasks

  useEffect(() => {
    if (pdfWeeklyTasks && (!includePdfTasksNotes || pdfTasksNotes)) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, PatientAssistance]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [includePdfTasksNotes, pdfWeeklyTasks, pdfTasksNotes]); // Measures

  useEffect(() => {
    if (pdfMeasuresGraphImages && jsonMeasures) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, Measures]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfMeasuresGraphImages, jsonMeasures]); // Medications

  useEffect(() => {
    if (observation && agency && patient && includePdfMedicationsNotes === STRING_TRUE) {
      const clearScriptsIndex = asyncPdfDataReady.indexOf(ClearScripts);
      const shallowPdfDataReady = [...asyncPdfDataReady];

      if (clearScriptsIndex !== -1) {
        shallowPdfDataReady.splice(clearScriptsIndex, 1);
      }

      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: shallowPdfDataReady
      });
      observation.getWidgetPnNotes(patient === null || patient === void 0 ? void 0 : patient.patientNumber, agency, ENTITY_MEDICATION).then(res => {
        if (res) {
          dispatch({
            type: SET_PDF_MEDICATIONS_NOTES,
            payload: res
          });
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [agency, observation, patient, includePdfMedicationsNotes, pdfMedications]);
  useEffect(() => {
    if (includePdfMedicationsNotes === STRING_TRUE) {
      if (pdfMedications && pdfMedicationsNotes) {
        dispatch({
          type: SET_ASYNC_PDF_DATA_READY,
          payload: [...asyncPdfDataReady, ClearScripts]
        });
      }
    } else if (includePdfMedicationsNotes === STRING_FALSE) {
      if (pdfMedications) {
        dispatch({
          type: SET_ASYNC_PDF_DATA_READY,
          payload: [...asyncPdfDataReady, ClearScripts]
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [includePdfMedicationsNotes, pdfMedications, pdfMedicationsNotes]); // Orders & Notes

  useEffect(() => {
    if (pdfPSOComponents && pdfProgressNotes) {
      dispatch({
        type: SET_ASYNC_PDF_DATA_READY,
        payload: [...asyncPdfDataReady, ProgressNotes]
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pdfPSOComponents, pdfProgressNotes]);
  useEffect(() => {
    if (keycloak && agency && patient && patientStandingOrdersGlobal && reactPrintOn) {
      getPNOrders(keycloak, agency, patient === null || patient === void 0 ? void 0 : patient.patientNumber).then(res => {
        if (!isResponse(res)) {
          const psoComponents = toPSOComponents(res, patientStandingOrdersGlobal);
          dispatch({
            type: SET_PDF_PSO_COMPONENTS,
            payload: psoComponents
          });
        }
      });
    }
  }, [agency, patient, patientStandingOrdersGlobal, reactPrintOn]);
  const context = useMemo(() => ({
    pdfWeeklyTasks,
    includePdfTasksNotes,
    pdfTasksNotes,
    pdfCertAppSnapshot,
    includePdfCertApp,
    pdfFacesheetData,
    pdfCareGiversInfo,
    jsonMeasures,
    pdfMeasuresGraphImages,
    pdfMedications,
    pdfMedicationsNotes,
    includePdfMedicationsNotes,
    includepdfBereavNotes,
    pdfBereavNotes,
    pdfPSOComponents,
    pdfProgressNotes,
    getAllRgHashes,
    pdfCarePlanProblems,
    asyncPdfDataReady,
    pdfCpfNotes,
    includePdfCpfNotes,
    pdfRgHash,
    pdfRgHashPrint,
    historicalRows,
    reactPrintOn,
    dispatchReactPDF: dispatch
  }), [pdfWeeklyTasks, includePdfTasksNotes, pdfTasksNotes, pdfCertAppSnapshot, includePdfCertApp, pdfFacesheetData, pdfCareGiversInfo, jsonMeasures, pdfMeasuresGraphImages, pdfMedications, pdfMedicationsNotes, includePdfMedicationsNotes, includepdfBereavNotes, pdfBereavNotes, pdfPSOComponents, pdfProgressNotes, asyncPdfDataReady, pdfCarePlanProblems, pdfCpfNotes, includePdfCpfNotes, pdfRgHash, pdfRgHashPrint, historicalRows, reactPrintOn, dispatch]);
  return /*#__PURE__*/React.createElement(MummsPDFGlobalContext.Provider, {
    value: context
  }, children);
};
export function withMummsPDFGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(MummsPDFGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(MummsPDFGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default MummsPDFGlobalContext;